var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBscWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41029 14.0001L7.42084 17.8684L10.7077 19.8025V22.0672L5.49727 19.0112V12.8689L7.41029 14.0001ZM7.41029 10.1319V12.386L5.49609 11.2537V8.99953L7.41029 7.86719L9.33386 8.99953L7.41029 10.1319ZM12.0803 8.99953L13.9945 7.86719L15.9181 8.99953L13.9945 10.1319L12.0803 8.99953Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79297 17.0666V14.8019L10.7072 15.9342V18.1884L8.79297 17.0666ZM12.0798 20.6136L13.994 21.746L15.9176 20.6136V22.8678L13.994 24.0001L12.0798 22.8678V20.6136ZM18.6628 8.99953L20.577 7.86719L22.5006 8.99953V11.2537L20.577 12.386V10.1319L18.6628 8.99953ZM20.577 17.8684L20.5876 14.0001L22.5018 12.8678V19.0101L17.2914 22.066V19.8013L20.577 17.8684Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2052 17.0674L17.291 18.1892V15.9351L19.2052 14.8027V17.0674Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2044 10.9335L19.215 13.1982L15.9187 15.1323V19.01L14.0045 20.1317L12.0904 19.01V15.1323L8.79414 13.1982V10.9335L10.7165 9.80119L13.9928 11.7447L17.289 9.80119L19.2126 10.9335H19.2044ZM8.79297 7.06646L13.994 4L19.2044 7.06646L17.2902 8.1988L13.994 6.2553L10.7072 8.1988L8.79297 7.06646Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBscWhite);
export default __webpack_public_path__ + "static/media/bsc-white.d9f71f4c0e2c15348c8aad6110ce9f96.svg";
export { ForwardRef as ReactComponent };